import React from 'react';

function HeroSlide({ children, className, style }) {
  return (
    <div 
      className={`hero-slide ${className || ''}`} 
      style={{ 
        backgroundColor: "#2a9d8f", 
        ...style 
      }}
    >
      <div className="hero-container" style={{ backgroundColor: "transparent" }}>
        {children}
      </div>
    </div>
  );
}

export default HeroSlide; 
